export { VehicleWalkaroundIndicator } from './VehicleWalkaroundIndicator';
export { type VehicleWalkaroundIndicatorProps } from './VehicleWalkaroundIndicator.types';
